import { Paper } from "@mui/material";
import { SeoHomeCalcio, SeoNewsCalcio, SeoNewsIppica } from "../shared/seo";
import './SeoSection.css';

const SeoSection = (props) => {
    console.log(props)
    const getSeoContent = () =>
    {
        switch(props.page) {
            case "home":
                return SeoHomeCalcio;
            case "news":
                return SeoNewsCalcio;
            case "ippica":
                return SeoNewsIppica;
            default:
                return SeoNewsCalcio;
        }
    };

    return <Paper className="seo-section" variant="outlined" sx={{marginTop:2, padding:2}}>
            { <div dangerouslySetInnerHTML={{ __html: getSeoContent() }}></div> } 
        </Paper>;
};

export default SeoSection;